<template>
  <div class="summary-status-icon">
    <component :is="loadIconPath" :iconColor="statusIcon.color" />
    <p class="summary-status-icon__title">
      {{ statusIcon.title }}
    </p>
    <p class="summary-status-icon__label" :style="{ color: statusIcon.color }">
      {{ statusIcon.label }}
    </p>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from "vue";

const props = defineProps({
  statusIcon: {
    type: Object,
  },
});

const loadIconPath = computed(() => {
  let iconImport;
  if (props.statusIcon.icon === "StatusActionRequired") {
    iconImport = import(
      /* @vite-ignore */ "@/components/icons/StatusActionRequired.vue"
    );
  } else if (props.statusIcon.icon === "StatusCompleted") {
    iconImport = import(
      /* @vite-ignore */ "@/components/icons/StatusCompleted.vue"
    );
  } else if (props.statusIcon.icon === "StatusFailed") {
    iconImport = import(
      /* @vite-ignore */ "@/components/icons/StatusFailed.vue"
    );
  } else {
    iconImport = import(
      /* @vite-ignore */ "@/components/icons/StatusPending.vue"
    );
  }

  return defineAsyncComponent(() => iconImport);
});
</script>

<style lang="scss">
.summary-status-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 3.4rem;

  p {
    padding-block: 0.15rem;
  }

  &__title {
    margin-top: 0.75rem;
  }
}
</style>
